// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__2yD8p","empty":"ModalGraph_empty__3vETT"};